class CopyLink {
  constructor() {
    this.selectors = {
      component: '.copy-link',
    };
  }

  copyLink() {
    $(this.selectors.component).on('click', () => {
      // getting page url
      const content = window.location.href;
      // loading the content into our clipboard
      navigator.clipboard.writeText(content);
    });
  }

  init() {
    this.copyLink();
  }
}

export default new CopyLink();
